import { BaseModel } from './base';

export class InventoryCategoryDto extends BaseModel {
  id?: string;
  categoryName: string;
  subscriberId: string;
  siteId: string;
}
